import { styled } from '@mui/material/styles';
import Typography, { TypographyProps } from '@mui/material/Typography';
import { SxProps, Theme } from '@mui/material/styles';

// Styled component avec typage correct et accès au theme
const BlueSpan = styled('span')<{ sx?: SxProps<Theme> }>(({ theme }) => ({
  fontWeight: 500,
  fontFamily: '"Poppins Medium", sans-serif',
  fontSize: 14,
  lineHeight: '19.6px',
}));

export interface SingleLineTextProps {
  text?: string | React.ReactNode;
  span?: string;
  onClick?: (event: React.MouseEvent<HTMLElement>) => void; // Type d'événement précis
  id?: string;
  className?: string;
  variant?: TypographyProps['variant']; // Utilise les variants MUI natifs
  sx?: SxProps<Theme>;
  sxSpan?: SxProps<Theme>;
}

import React from 'react';

const SingleLineText = ({
  text,
  span,
  onClick,
  id,
  className,
  variant = 'body1',
  sx,
  sxSpan,
}: SingleLineTextProps): React.ReactElement => {
  return React.createElement(
    Typography,
    {
      id,
      className,
      variant,
      sx,
      onClick,
    },
    text,
    span && React.createElement(BlueSpan, { sx: sxSpan }, span),
  );
};

export default SingleLineText;
export { SingleLineText };
